import FieldProfileSlug from './ducks/FieldProfileSlug.duck';

export default { FieldProfileSlug };
